// Bare minimum behaviors for allowing tab nav / screen reader controls to open desktop nav items
document.addEventListener('DOMContentLoaded', function() {
    // Set interval limits to prevent infinite runtime
    let setIntervalLimit = 5;
    let setIntervalLimitCount = 0;

    // Check if the Qikify desktop menu wrapper is loaded
    function checkIfDesktopMenuLoaded() {
        setIntervalLimitCount++;
        let qikifyMenuWrapper = document.querySelector('ul.tmenu_nav');

        if (qikifyMenuWrapper) {
            clearInterval(scriptLoadCheckInterval);
            accessibleDesktopNavigation();
        }
        // Stop checking if the limit is reached
        if (setIntervalLimitCount >= setIntervalLimit) {
            clearInterval(scriptLoadCheckInterval);  // Stop the interval
        }
    }
    const scriptLoadCheckInterval = setInterval(checkIfDesktopMenuLoaded, 100);
    
    // Execute accessibility script after menu loaded
    function accessibleDesktopNavigation() {
        // Gather desktop menu vars
        const desktopRootMenuItems = document.querySelectorAll('header nav.tmenu_navbar ul.tmenu_nav li.tmenu_item.tmenu_item--root > a.tmenu_item_link');
        desktopRootMenuItems

        // Manage submenu visibility for tab navigators by emulating mouse enter/mouse for keyboard nav
        desktopRootMenuItems.forEach(desktopRootMenuItem => {
            const desktopRootMenuItemWrapper = desktopRootMenuItem.parentElement;
            // Emulate mouseenter event on focusin of main nav items
            desktopRootMenuItem.addEventListener('focusin', function() {
                desktopRootMenuItemWrapper.dispatchEvent(new Event('mouseenter'));
            });
            // Emulate mouseleave event on focusout of main nav item or submenu
            desktopRootMenuItemWrapper.addEventListener('focusout', function(event) {
                if (!desktopRootMenuItemWrapper.contains(event.relatedTarget)) {
                    desktopRootMenuItemWrapper.dispatchEvent(new Event('mouseleave'));
                }
            });
        });
    }
});

/* Update SKU on variant switch */
window.addEventListener('product-variant-switch',function(event){
    const variant=event.detail&&event.detail.variant;if(!variant)return;
    const skuContainer=document.querySelector('.prod-sku');if(!skuContainer)return;
    skuContainer.textContent='';
    skuContainer.insertAdjacentHTML('beforeend','<b>SKU#:</b> '+(variant.sku||''));
  });
  
/* Update subtitle on variant switch */
window.addEventListener('product-variant-switch', function(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
  
    const subtitleContainer = document.querySelector('.product-variant-title');
    if (!subtitleContainer) return;
  
    const subtitleP = subtitleContainer.querySelector('p');
    if (!subtitleP) return;
  
    // Get enriched variant data from ProductJson
    const productDataEl = document.querySelector('[id^="ProductJson-"]');
    if (!productDataEl) return;
  
    try {
      const productData = JSON.parse(productDataEl.textContent);
      const enrichedVariant = productData.variants.find(v => v.id == variant.id);
  
      subtitleP.textContent = enrichedVariant?.subtitle || '';
    } catch (e) {
      console.warn('Subtitle update error:', e);
    }
  });


/* on product page, match all buttons to widest one */
  window.addEventListener('DOMContentLoaded', () => {
    const variantGroups = document.querySelectorAll('.product-page .swatch');

    variantGroups.forEach(group => {
      const elements = group.querySelectorAll('.swatch-label');
      let maxWidth = 0;

      elements.forEach(el => {
        const width = el.offsetWidth;
        if (width > maxWidth) {
          maxWidth = width;
        }
      });

      elements.forEach(el => {
        el.style.width = maxWidth + 'px';
      });
    });
  });

/* Add about this item event listener if missing */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    document.querySelectorAll('.variant_desc').forEach(function(el) {
      if (!el.dataset.listenerAttached) {
        el.addEventListener('click', function() {
          this.classList.toggle('open');
        });
        el.dataset.listenerAttached = 'true';
      }
    });
  }, 500);
});

/* Collapses the filter at 600px rather 400px 
window.addEventListener('load', function () {
  const breakpoint = 600;
  const detailsElements = document.querySelectorAll('#sorting details:not(#filters details)');

  if (window.innerWidth <= breakpoint) {
    detailsElements.forEach((el) => {
      // Remove 'open' immediately after full page load
      el.removeAttribute('open');

      // Watch for any attempt to re-add it
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            el.removeAttribute('open');
          }
        });
      });

      observer.observe(el, { attributes: true });
    });
  }
});
*/

// Product page - custom tooltips dynamic placement in DOM on hover and click
document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector('main.product-page')) return;

    var customTooltipsTriggers = document.querySelectorAll('div.variants-wrapper fieldset legend .product-details-tooltip');
    if (customTooltipsTriggers.length === 0) return;

    // Tooltip positioning function
    function positionTooltip(tooltip, triggerRect) {
        var tooltipWidth = tooltip.offsetWidth;
        var tooltipHeight = tooltip.offsetHeight;
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;
        var scrollY = window.scrollY;
        var padding = 15;
    
        // Horizontal Positioning
        var newLeftPosition = triggerRect.left + (triggerRect.width / 2) - (tooltipWidth / 2);
        if (newLeftPosition < padding) {
            newLeftPosition = padding;
        } else if (newLeftPosition + tooltipWidth > viewportWidth - padding) {
            newLeftPosition = viewportWidth - tooltipWidth - padding;
        }
    
        // Vertical Positioning
        var newTopPosition;
        var spaceBelow = viewportHeight - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        
        // Position below if there is enough space, else position above if enough space
        if (spaceBelow >= tooltipHeight + 10) {
            newTopPosition = triggerRect.bottom + scrollY + 10;
        }
        else if (spaceAbove >= tooltipHeight + 10) {
            newTopPosition = triggerRect.top + scrollY - tooltipHeight - 10;
        }
        // Fallback to place in direction with most space
        else {
            if (spaceBelow >= spaceAbove) {
                newTopPosition = Math.min(triggerRect.bottom + scrollY + 10, viewportHeight + scrollY - tooltipHeight - padding);
            } else {
                newTopPosition = Math.max(triggerRect.top + scrollY - tooltipHeight - 10, scrollY + padding);
            }
        }
    
        tooltip.style.left = `${newLeftPosition}px`;
        tooltip.style.top = `${newTopPosition}px`;
    }

    // Handle tooltip content display
    customTooltipsTriggers.forEach(function (trigger) {
        let activeTooltip = null;
        let tooltipTimeout = null;
        let isClickedTooltip = false;

        const tooltipContent = trigger.querySelector('p')?.innerHTML || '';

        // Close display when clicking outside of content or its trigger
        function handleOutsideClick(event) {
            if (
                activeTooltip &&
                !trigger.contains(event.target) &&
                !activeTooltip.contains(event.target)
            ) {
                activeTooltip.remove();
                activeTooltip = null;
                isClickedTooltip = false;
                document.removeEventListener('click', handleOutsideClick);
            }
        }

        // Hover toggle behaviors
        trigger.addEventListener('mouseenter', function (event) {
            clearTimeout(tooltipTimeout);
            if (activeTooltip) return;

            activeTooltip = document.createElement('div');
            activeTooltip.innerHTML = tooltipContent;
            activeTooltip.classList.add('dynamic-tooltip');
            document.body.appendChild(activeTooltip);

            const rect = event.currentTarget.getBoundingClientRect();
            positionTooltip(activeTooltip, rect);
        });

        trigger.addEventListener('mouseleave', function () {
            tooltipTimeout = setTimeout(() => {
                if (activeTooltip && !isClickedTooltip) {
                    activeTooltip.remove();
                    activeTooltip = null;
                }
            }, 100);
        });

        // Click toggle behaviors
        trigger.addEventListener('click', function (event) {
            event.stopPropagation();

            if (activeTooltip && isClickedTooltip) {
                activeTooltip.remove();
                activeTooltip = null;
                isClickedTooltip = false;
                document.removeEventListener('click', handleOutsideClick);
            } else {
                if (activeTooltip) {
                    activeTooltip.remove();
                }
                // Create tooltip content element
                activeTooltip = document.createElement('div');
                activeTooltip.innerHTML = tooltipContent;
                activeTooltip.classList.add('dynamic-tooltip');
                document.body.appendChild(activeTooltip);

                const rect = event.currentTarget.getBoundingClientRect();
                positionTooltip(activeTooltip, rect);

                isClickedTooltip = true;
                // Delay so it doesn’t instantly close itself
                setTimeout(() => {
                    document.addEventListener('click', handleOutsideClick);
                }, 0);
            }
        });
    });
});